export const faqData = [
  {
    category: 'About Escape Plan',
    faq: [
      {
        title: 'What is Escape Plan?',
        content:
          'Escape Plan is a professional provider of fire escape plan and blueprint services. We convert your building drawings into clear, compliant CAD files and print-ready PDF escape plans, ensuring accuracy, clarity, and regulatory compliance.',
      },
      {
        title: 'What services does Escape Plan offer?',
        content:
          'We create compliant fire escape plans, redraw and standardise existing drawings, and provide print-ready PDFs with optional professional printing and delivery.',
      },
      {
        title: 'How does Escape Plan work?',
        content:
          'You upload your plans, we redraw and standardise them to meet regulations, and you receive a ready-to-display escape plan PDF or printed signage.',
      },
    ],
  },
  {
    category: 'Using Escape Plan',
    faq: [
      {
        title: 'How can I upload my building drawings to Escape Plan?',
        content:
          'You can upload PDFs, CAD files, images, or even hand-drawn sketches directly through our platform.',
      },
      {
        title:
          "Can I customise the escape plans to my building's specifications?",
        content:
          'Yes. All escape plans are tailored to your building layout, exits, fire equipment, and compliance requirements.',
      },
      {
        title: 'How long does it take to receive the completed escape plans?',
        content:
          'Most plans are completed quickly, with fast turnaround available for urgent inspections.',
      },
      {
        title: 'How can I track the progress of my project?',
        content:
          'You can track progress directly from your dashboard and review updates as the plan moves through each stage.',
      },
      {
        title: 'Can I cancel or modify my project after submission?',
        content:
          'Yes, you can request changes or updates while the plan is still in progress.',
      },
    ],
  },
  {
    category: 'Materials and Payments',
    faq: [
      {
        title: 'What materials are used for printing the escape plans?',
        content:
          'We offer A4 and A3 prints, with options for lamination or rigid board mounting.',
      },
      {
        title: 'What payment methods are accepted?',
        content:
          'We accept all major payment methods through our secure checkout.',
      },
      {
        title: 'Are there any additional fees?',
        content:
          'All pricing is transparent, with optional costs only for printing and delivery.',
      },
    ],
  },
  {
    category: 'Support and Security',
    faq: [
      {
        title: 'Is customer support available?',
        content:
          'Yes. Our support team is available to assist you at every stage of your project.',
      },
      {
        title: 'Is my data secure?',
        content:
          'Yes. We take data security seriously and protect all uploaded files and personal information.',
      },
    ],
  },
  {
    category: 'Feedback and Discounts',
    faq: [
      {
        title: 'Can I leave feedback after completion?',
        content:
          'Yes. We welcome feedback and reviews once your project is complete.',
      },
      {
        title: 'Are discounts available for repeat customers?',
        content:
          'Yes. We offer discounts for recurring projects and bulk orders.',
      },
    ],
  },
  {
    category: 'Fire Escape Plan Compliance',
    faq: [
      {
        title: 'What if my plans are old or inaccurate?',
        content:
          'That’s fine. We redraw and standardise everything before producing the final escape plan, ensuring it is clear, accurate, and suitable for display.',
      },
      {
        title: 'Will this pass inspection?',
        content:
          'Our plans are designed specifically for compliance and display purposes and are widely accepted for inspections and insurance checks.',
      },
      {
        title: 'Can you print the signs for me?',
        content:
          'Yes. We offer professional printing and delivery, so you receive ready-to-mount escape plan signage.',
      },
      {
        title: 'Do I need one plan per floor?',
        content:
          'Yes. Typically, each floor requires its own displayed escape plan so occupants can clearly see the correct escape routes for their level.',
      },
    ],
  },
];
export const complianceFaqData = {
  category: 'Fire Escape Plan Compliance & Inspections',
  faq: [
    {
      title: 'Will these fire escape plans pass a fire inspection?',
      content:
        'Yes. Our fire escape plans are specifically prepared for display and inspection purposes. They clearly show escape routes, emergency exits, assembly points, fire equipment locations, and floor layout context. They are suitable for review by fire officers, local authorities, health & safety inspectors, and insurance assessors.',
    },
    {
      title: 'Are fire escape plans legally required?',
      content:
        'In most cases, yes. If you operate a hotel, guesthouse, construction site, office, retail unit, workplace, or shared multi-occupancy building, you are generally expected to display clear fire escape signage. These are commonly checked during fire safety inspections, insurance renewals, building certification, and site audits.',
    },
    {
      title: 'What happens if I don’t have escape plans displayed?',
      content:
        'Missing or inadequate fire escape signage can delay certification or approval, result in inspection failures, lead to follow-up inspections, and cause insurance issues. Escape Plan is designed to remove this risk by providing clear, professional, display-ready plans.',
    },
    {
      title: 'Do you follow fire safety regulations?',
      content:
        'We prepare plans according to standard fire escape signage expectations, including clear route visibility, logical exit paths, consistent symbols and layout, and readability when wall-mounted. Final responsibility for site-specific compliance remains with the building owner or operator.',
    },
    {
      title: 'Will inspectors accept digitally produced plans?',
      content:
        'Yes. Inspectors care about accuracy, clarity, visibility, and correct information. They do not require plans to be hand-drawn or produced using a specific software package. Our output is professional, clean, and purpose-built for display.',
    },
    {
      title: 'Do I need one escape plan per floor?',
      content:
        'In most cases, yes. Each floor typically requires its own displayed escape plan showing routes relevant to that level and clear “You Are Here” context where applicable. We assess this automatically when reviewing your upload.',
    },
    {
      title: 'What if my plans are old, incomplete, or messy?',
      content:
        'That’s completely fine. You can upload old PDFs, scanned drawings, photos, or hand-drawn sketches. We redraw and standardise everything before producing the final escape plan.',
    },
    {
      title: 'What if my building layout has changed?',
      content:
        'We update escape routes based on your uploaded drawings and any notes you provide. If clarification is needed, we’ll contact you. Uploading the most recent layout helps ensure accuracy.',
    },
    {
      title: 'How quickly can I get plans before an inspection?',
      content:
        'Turnaround is fast and depends on complexity. If you are under inspection pressure, upload your plans immediately and mention your deadline. Express turnaround options are available.',
    },
    {
      title: 'Can you print and deliver the signs for me?',
      content:
        'Yes. You can choose download-only to print locally, or printed and posted plans delivered ready to mount. This is especially popular with hotels, construction sites, and property managers.',
    },
    {
      title: 'What size should fire escape signs be?',
      content:
        'Common sizes include A4 and A3. The correct size depends on viewing distance, corridor width, and mounting location. We prepare files suitable for standard display sizes and can advise if larger formats are required.',
    },
    {
      title: 'Can I show these plans to my insurer?',
      content:
        'Yes. These plans are suitable for insurance documentation, risk assessments, and safety records. Many customers include them as part of their fire safety file.',
    },
    {
      title: 'What if an inspector asks for changes?',
      content:
        'Minor changes are easy. Each plan includes at least one revision, and we’ll clearly communicate any updates needed. Our goal is to help you get compliant, not stuck in revisions.',
    },
    {
      title: 'Do I need to create an account first?',
      content:
        'No. You can upload your plans first. We only collect your details once the assessment is complete.',
    },
    {
      title: 'Still unsure?',
      content:
        'If you’re preparing for an inspection or insurance review, the safest option is to upload your plans and let us assess them. Uploading early helps avoid last-minute issues.',
    },
  ],
};
